<template>
    <v-dialog v-model="dialog" persistent max-width="500">
        <v-card>
            <v-btn
            icon
            absolute
            top
            right
            @click="$emit('closeModal')"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <br>
            <v-card-title class="d-flex justify-center">
                <p class="text-center primary--text">Audit Log Details</p>
            </v-card-title>
            <v-card-text>
                <p><b>Name : </b> {{ `${detail.admin.profile.firstname}&nbsp;${detail.admin.profile.lastname} ( ${detail.admin.email} )` }}</p>
                <p><b>Action : </b>{{detail.action}}</p>
                <p><b>Action Time : </b>{{formatDate(detail.actionTime)}} <span class="primary--text">@</span> {{formatTime(detail.actionTime)}}</p>
                <p><b>Time Created : </b>{{formatDate(detail.created)}} <span class="primary--text">@</span> {{formatTime(detail.created)}}</p>
                <p><b>Status : </b>
                    <v-chip label class="pa-3" :title="detail.details" :color="status(detail.status)">
                        <span class="pa-4">{{detail.status}}</span>
                    </v-chip>
                </p>
                <div>
                    <p class="mb-0 info--text"><b>Details</b></p> 
                    <div class="black white--text pa-2 text-capitalize rounded">
                        {{name(detail.details)}}
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { parseTimestamp } from '@/utils/dates';
export default {
    props:{
        dialog:{
            type:Boolean,
        },
        detail:{
            type: Object
        }
    },
    methods:{
        name(name){
            return name.replace(/_/g,' ')
        },
        status(color){
            let data;
            if(color == "successful"){
                data = "success"
            }
            else if(color == "failed"){
                data = "error"
            }
            return data
        },
        formatDate(date){
            let d = new Date(date)
            let reModelDate = d.toLocaleString(["en-Us"], {
                month: "short",
                day: "2-digit",
                year: "numeric",
            });
            return reModelDate;
        },
        formatTime(time){
            return parseTimestamp(new Date(time), 'HH:mm');
        },
    }
}
</script>